'use strict';

var base = require('../product/base');

function selectAddonAttribute(attrName, attrValue, addonContainer) {
    if (addonContainer.length) {

        $.each(addonContainer, function () {
            var attributes = $(this).find('.js-attribute');

            $.each(attributes, function () {
                var thisAddonVariant = $(this).data('attrname');
                if (thisAddonVariant === attrName) {
                    // Check attribute is available as an option
                    var isOptionAvailable = $(this).find('select.js-select-attr option[data-displayvalue="' + attrValue + '"]');
                    if (isOptionAvailable && isOptionAvailable.length > 0) {
                        var thisValue = isOptionAvailable.val();
                        var isDisabled = $(this).find('select.js-select-attr option[value="' + thisValue + '"]').is(':disabled');
                        var currentSelectvalue = $(this).find('select.js-select-attr').val();
                        if (thisValue && !isDisabled && currentSelectvalue != thisValue) {
                            $(this).find('select.js-select-attr').selectpicker('val', thisValue);
                        }
                    }
                    return false;
                }
            });
        });
    }
}

// Set default selected attribute
function setDefaultAttribute() {
    if ($('.rec-addons .product') && $('.rec-addons .product').length > 0) {
        var items = $('.rec-addons .product');
        var hasNonselectedAttrs = false;

        $.each(items, function () {
            var itemAttributes = $(this).find('.js-items-attr');
            if (itemAttributes && itemAttributes.length > 0) {
                $.each(itemAttributes, function () {
                    var selectedAttr = $(this).find('.selectable.selected');
                    var value = '';
                    if (selectedAttr && selectedAttr.length > 0) {
                        // If there's only 1 attribute available, it's already selected by default.
                        value = selectedAttr.data('displayvalue');

                        if (value && value.length > 0) {
                            var selectAttribute = $(this).closest('.js-attribute').find('select.js-select-attr option[data-displayvalue="' + value + '"]');
                            var optionValue = selectAttribute.attr('value');
                            if (optionValue) {
                                $(this).closest('.js-attribute').find('select.js-select-attr').selectpicker('val', optionValue);
                            }
                        }
                    } else {
                        hasNonselectedAttrs = true;
                        $(this).closest('.js-attribute').addClass('js-attrNotSelected');
                    }
                });
            }
        });

        // for timing reasons, select attrs
        if (hasNonselectedAttrs) {
            initSelectNextAttr();
        }
    }
}

function selectNextAttr(attribute) {
    return new Promise(function (resolve, reject) {
        if (attribute == null) { return };

        // set one at a time so we get previous attr into URL to avoid timing issue
        var selectableAttrs = attribute.find('.js-items-attr .selectable');
        var firstSelectableAttr = $(selectableAttrs[0]);
        var value = firstSelectableAttr.data('displayvalue');

        if (value && value.length > 0) {
            var selectAttribute = attribute.find('select.js-select-attr option[data-displayvalue="' + value + '"]');
            var optionValue = selectAttribute.attr('value');
            if (optionValue) {
                    attribute.find('select.js-select-attr').selectpicker('val', optionValue);
            }
            resolve();
        }
    });
}

function initSelectNextAttr() {
    var notSelectedAttrs = $('.js-attrNotSelected');
    if (notSelectedAttrs && notSelectedAttrs.length > 0) {
        var hasSelected = notSelectedAttrs.find('.js-items-attr .selected');
        if (hasSelected.length > 0) {
            notSelectedAttrs.removeClass('js-attrNotSelected');
        } else {
            var attribute = $(notSelectedAttrs[0]);

            selectNextAttr(attribute).then(function (data) {
                if ($('.js-attrNotSelected') && $('.js-attrNotSelected').length > 0) {
                    setTimeout(function () {
                        initSelectNextAttr();
                    }, 500);
                }
            });
        }

    }
}

function selectSingleOptionAttribute (container) {
    if (container && container.length) {
        var singleOption = container.find('.other-attribute.selectable.selected');

        if (singleOption && singleOption.length &&
            singleOption.find('.variant-value').data('attr-value') == 'single') {
            singleOption.click();
        }
    }
}

$('.rec-addons #nonswatch-select, .rec-addons #swatch-picker-select').on("changed.bs.select", function (e) {
    var selected = $(e.currentTarget).val();
    var itemVariation = $(this).closest('.item__content__attr').find('.js-items-attr');
    if (itemVariation.find(".variant-value.selected, .selection-button.selected").data('attr-value') !== selected) {
        if (selected != '') {
            itemVariation.find("[data-attr-value='" + selected + "']").closest('.selectable').click();
        } else {
            // unselect current attribute
            var thisAttrButton = $(this).closest('.js-attribute').find('.js-items-attr button.selected');
            if (thisAttrButton) {
                thisAttrButton.click();
            }
        }
    }
});

// Update product add-on attributes to match selected attributes on main product
if ($('.rec-addons').length > 0) {
    if ($('.main-product .attribute button').on('click', function() {
        var attrName = $(this).closest('.attribute').attr('data-attrname');
        var attrValue = $(this).data('displayvalue');
        var addonContainer = $(this).closest('.product-wrapper').find('.js-isAddOnProduct');

        if (attrName && attrValue) {
            selectAddonAttribute(attrName, attrValue, addonContainer);
        }
    }));

    setDefaultAttribute();
}

$('.addon-checkbox').on('click', function (e) {
    if (this.checked) {
        selectSingleOptionAttribute($(e.currentTarget).closest('.js-isAddOnProduct'));
    }
    base.validateAddToCartButton();
});
